import Input from 'rc-input'
import './index.css'

export default Input
